<!-- 设备管理 -->
<template>
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备名称')">
                <j-input :placeholder="$t('请输入设备名称')" v-model="queryParam.deviceName"></j-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="状态">
                <a-input placeholder="请输入状态" v-model="queryParam.ticketsNum"></a-input>
              </a-form-item>
            </a-col> -->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备类型')">
                <j-dict-select-tag v-model="queryParam.deviceType" :dictCode="'deviceType'" :showSearch="false" :placeholder="$t('请选择设备类型')" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
  
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
        <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
        <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload> -->
        <!-- 高级查询区域 -->
        <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          class="j-table-force-nowrap"
          @change="handleTableChange">
  
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text,record">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
            <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(text)">
              {{ $t('下载') }}
            </a-button>
          </template>
  
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
            <a-divider type="vertical" />
            <a @click="handleHistory(record)">{{ $t('历史数据') }}</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('删除') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
  
        </a-table>
      </div>
  
      <deviceModal ref="modalForm" @ok="loadData"></deviceModal>
      <historyModal ref="historyForm" @ok="loadData"></historyModal>
    </div>
  </template>
  
  <script>
  
    import '@/assets/less/TableExpand.less'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {
      httpAction,
      getAction,
      postAction
    } from '@/api/manage'
    import deviceModal from './modules/deviceModal'
    import historyModal from './modules/historyModal'
    import {
      filterDictTextByMany,
      filterDictTextByCache
    } from '@/components/dict/JDictSelectUtil';
    import JInput from '@/components/jeecg/JInput'
  
    export default {
      name: 'lineList',
      mixins:[JeecgListMixin, mixinDevice],
      components: {
        deviceModal,
        historyModal,
        JInput
      },
      data () {
        return {
          url: {
            list: "/jeecg-engineering/inspection/inspectionDevice/list",
            delete: "/jeecg-engineering/inspection/inspectionDevice/delete",
            deleteBatch: "/jeecg-engineering/inspection/inspectionDevice/deleteBatch",
            exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
            importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
          },
          dictOptions:{},
          superFieldList:[],
        }
      },
      created() {},
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        },
        description() {
          return this.$t('设备管理页面')
        },
        // 表头
        columns() {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender: (t,r,index) => {
                return parseInt(index)+1;
              }
            },
            {
              title: this.$t('设备编号'),
              align:"center",
              dataIndex: 'deviceNum'
            },
            {
              title: this.$t('设备名称'),
              align:"center",
              dataIndex: 'deviceName'
            },
            {
              title: this.$t('设备类型'),
              align:"center",
              dataIndex: 'deviceType',
              customRender: (text) => {
                return filterDictTextByCache('deviceType', text)
              }
            },
            {
              title: this.$t('设备描述'),
              align:"center",
              dataIndex: 'deviceDetail'
            },
            // {
            //   title:'设备经度',
            //   align:"center",
            //   dataIndex: 'detectLongitude'
            // },
            // {
            //   title:'设备纬度',
            //   align:"center",
            //   dataIndex: 'detectLatitude'
            // },
            // {
            //   title:'备注',
            //   align:"center",
            //   dataIndex: 'remark'
            // },
            {
              title: this.$t('操作'),
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:160,
              scopedSlots: { customRender: 'action' }
            }
          ]
        },
      },
      methods: {
        // 详情
        // handleDetail(row){
        //   this.$nextTick(()=>{
        //     this.$refs.modalForm.init(row);
        //   })
        // },
        handleHistory(row){
          this.$nextTick(()=>{
            this.$refs.historyForm.init({...row,isMap:true});
          })
        },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>